import { z } from "zod";

/**
 * Schema de validação para empresas
 * Usado em páginas CRUD de companies
 */
export const companySchema = z.object({
	name: z.string().min(1, "Nome é obrigatório").max(255, "Nome muito longo"),

	legal_name: z
		.string()
		.max(255, "Razão social muito longa")
		.optional()
		.or(z.literal("")),

	informal_name: z
		.string()
		.max(255, "Nome fantasia muito longo")
		.optional()
		.or(z.literal("")),

	cnpj: z.string().max(18, "CNPJ inválido").optional().or(z.literal("")),

	email: z.string().email("Email inválido").optional().or(z.literal("")),

	phone: z
		.string()
		.max(20, "Telefone muito longo")
		.optional()
		.or(z.literal("")),

	site: z.string().url("URL inválida").optional().or(z.literal("")),

	logo_url: z.string().url("URL inválida").optional().or(z.literal("")),

	description: z.string().optional().or(z.literal("")),

	tagline: z
		.string()
		.max(255, "Slogan muito longo")
		.optional()
		.or(z.literal("")),
});
